export const GET_WISHLIST = "GET_WISHLIST";
export const ADD_PRODUCTS_TO_WISHLIST = "ADD_PRODUCTS_TO_WISHLIST";
export const DELETE_WISHLIST= "DELETE_WISHLIST";
export const DELETE_PRODUCTS_FROM_WISHLIST = "DELETE_PRODUCTS_FROM_WISHLIST";
export const SET_IS_LOADING_WISHLIST = "SET_IS_LOADING_WISHLIST";